import { render } from "./ErrorActionModal.vue?vue&type=template&id=a8ddf632&scoped=true"
import script from "./ErrorActionModal.vue?vue&type=script&lang=js"
export * from "./ErrorActionModal.vue?vue&type=script&lang=js"

import "./ErrorActionModal.vue?vue&type=style&index=0&id=a8ddf632&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8ddf632"]])

export default __exports__